import React from 'react'
import { ArrowBack } from '@mui/icons-material'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

export const BackButton = (props: any) => {
  const { steps = -1 } = props
  const navigate = useNavigate()

  return <Button
    variant='contained'
    onClick={() => navigate(steps)}
    sx={{ marginBottom: 5 }}>
    <ArrowBack /> Back
  </Button>
}